<template>
    <div class="search-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>搜索结果</el-breadcrumb-item>
        </el-breadcrumb>
        <el-tabs type="border-card" slot="content" class="rank-box zy-list" @tab-click="handleChangeCard">
            <el-tab-pane label="学校" :key="1">
                <el-row class="collapse-box">
                    <div v-if="searchSchoolStatus == '3'">
                        <div class="collapse-list" v-for="(item,index) in schoolList" :key="index">
                            <el-col :span="3">
                                <el-image :src="'https://gaokao.zmpajx.com/pic/' + item.scl_id + '.jpg'" alt="大学logo">
                                    <div slot="error" class="image-slot">
                                        <img src="../../assets/images/scl_default.png" alt="大学logo">
                                    </div>
                                </el-image>
                            </el-col>
                            <el-col :span="17">
                            <div class="zytb-school-name" v-if="item.city_name">
                                {{item.scl_name}}<img src="../../assets/images/wz.png" alt="位置" v-if="item.city_name">
                                <span v-if="item.city_name">{{item.province_name == '北京' || item.province_name == '天津' || item.province_name == '上海' || item.province_name == '重庆' ? '' : item.province_name}}{{item.city_name}}</span>
                            </div>
                            <div class="zytb-school-tag">
                                <!-- <template v-if="item.scl_nature_type == '6000'">
                                    <span v-if="item.f211 == '1' || item.f985 == '1' || item.is_provincial == '1' || (item.dual_class != '38003' && item.dual_class)">
                                        本科
                                    </span>
                                    <span v-else>
                                        普通本科
                                    </span>
                                </template>
                                <template v-if="item.scl_nature_type == '6001'">
                                    <span v-if="item.is_doublehigh == '77'">
                                        专科
                                    </span>
                                    <span v-else>
                                        普通专科
                                    </span>
                                </template> -->
                                <span>{{type_edu[item.scl_nature_type]}}</span>
                                <span v-if="item.scl_type == '5000'">综合</span>
                                <span v-if="item.scl_type == '5001'">理工</span>
                                <span v-if="item.scl_type == '5002'">农林</span>
                                <span v-if="item.scl_type == '5003'">医药</span>
                                <span v-if="item.scl_type == '5004'">师范</span>
                                <span v-if="item.scl_type == '5005'">语言</span>
                                <span v-if="item.scl_type == '5006'">财经</span>
                                <span v-if="item.scl_type == '5007'">政法</span>
                                <span v-if="item.scl_type == '5008'">体育</span>
                                <span v-if="item.scl_type == '5009'">艺术</span>
                                <span v-if="item.scl_type == '5010'">民族</span>
                                <span v-if="item.scl_type == '5011'">军事</span>
                                <span v-if="item.scl_type == '5012'">其他</span>
                                <span v-if="item.scl_nature == '36000'">公办</span>
                                <span v-if="item.scl_nature == '36001'">民办</span>
                                <span v-if="item.scl_nature == '6002'">中外合作办学</span>
                                <span v-if="item.f211 == '1'" style="background:#fff4e3;color:#fe9f0a;">211</span>
                                <span v-if="item.f985 == '1'" style="background:#fff0e9;color:$common-color;">985</span>
                                <span v-if="item.dual_class != '38003' && item.dual_class" style="background:#e4f4e9;color:#01c13b;">双一流</span>
                                <span v-if="item.is_provincial == '1'" style="background: #FDEFFF;color: #D250E0">省重点</span>
                                <span v-if="item.is_doublehigh == '77'" style="background: #ECEDFF;color: #5964FF">双高计划</span>
                            </div>
                            </el-col>
                            <el-col :span="4">
                                <el-button @click="schoolDetailHandler(item.scl_id)">查看学校详情</el-button>
                            </el-col>
                            <div class="con-clear"></div>
                            <el-row class="con-line"></el-row>
                        </div>
                    </div>
                    <div class="no-data-box" v-else-if="searchSchoolStatus == '2'">
                        <img src="../../assets/images/null.png" alt="没有数据">
                        <p>没有找到你搜索的大学</p>
                    </div>
                    <el-pagination
                        background
                        layout="prev, pager, next, jumper"
                        :total="totalData" :page-size="20" @current-change="getSchoolListHandler" :current-page.sync="currentPage" v-if="totalData > 0">
                    </el-pagination>
                    <div v-if="searchSchoolStatus == '1'">
                        <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="70" width="670" viewBox="0 0 670 110" v-for="item in 20" :key="item">
                            <rect x="45" y="12" width="117" height="15" />
                            <rect x="45" y="32" width="140" height="15" />
                            <rect x="610" y="15" width="80" height="20" />
                            <circle cx="20" cy="35" r="20" />
                            <rect x="45" y="69" width="725" height="1" />
                        </ContentLoader>
                    </div>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="专业" :key="2">
                <el-row class="collapse-box collapse-box1">
                    <div v-if="searchMajorStatus == '3'">
                        <div class="collapse-list" v-for="(item,index) in levelList" :key="index">
                            <h2>{{item.level2_name}}</h2>
                            <div v-for="(item1,index1) in item.levelList" :key="index1">
                            <h4>{{item1.level3_name}}</h4>
                            <div class="major-list" v-for="(item2,index2) in item1.levelList1" :key="index2">
                                <el-row class="major-infor">
                                <el-col :span="17">
                                <div class="zytb-school-name">
                                    {{item2.special_name}}
                                </div>
                                <div class="zytb-school-tag">
                                    <span>现修年限{{item2.limit_year ? item2.limit_year: '--'}}</span>
                                    <span>授予学位:{{item2.degree ? item2.degree: '--'}}</span>
                                    <span>男女比例:{{item2.boy_rate}}/{{item2.girl_rate}}</span>
                                </div>
                                </el-col>
                                <el-col :span="4">
                                    <el-button @click="clickHandler(item2.special_id)">查看专业详情</el-button>
                                </el-col>
                                <div class="con-clear"></div>
                                <el-row class="con-line"></el-row>
                                </el-row>
                            </div>
                            </div>
                        </div>
                        <div class="con-clear"></div>
                    </div>
                    <el-pagination
                        background
                        layout="prev, pager, next, jumper"
                        :total="levelTotal" :page-size="20" @current-change="getSpecialListHandler" :current-page.sync='currentPage' v-if="levelTotal > 0">
                    </el-pagination>
                    <div v-else-if="searchMajorStatus == '2'" class="no-data-box">
                        <img src="../../assets/images/null.png" alt="没有数据">
                        <p>没有找到你搜索的专业</p>
                    </div>
                    <div v-else-if="searchMajorStatus == '1'">
                        <ContentLoader :base-url="$route.fullPath" height="150" width="670" primaryColor="#f0f2f5" secondaryColor="#EFEFEF"  v-for="item in 20" :key="item">
                            <rect x="0" y="15" width="40" height="16" />
                            <rect x="20" y="45" width="70" height="16" />
                            <rect x="20" y="85" width="30" height="16" />
                            <rect x="20" y="110" width="200" height="16" />
                            <rect x="610" y="100" width="80" height="16" />
                            <rect x="0" y="75" width="725" height="1" />
                            <rect x="20" y="149" width="725" height="1" />
                        </ContentLoader>
                    </div>
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { getSchoolList } from '@/api/school'
import { getSpecialList } from '@/api/major'
import { getSearchDic } from "@/api/zhiyuan"
import { ContentLoader } from 'vue-content-loader'
import { mapState } from 'vuex'
export default {
    components: {
        ContentLoader
    },
    data() {
        return {
            cardList: ['学校','专业'],
            searchSchoolStatus: '1',
            searchMajorStatus: '1',
            schoolList: [],
            levelList: [],
            keyWord: '',
            currentPage: 1,
            totalData: 0,
            levelTotal: 0,
            activeIndex: '0',
            type_edu: {}
        }
    },
    computed: {
        ...mapState({
            requestCount: state => state.user.requestCount,
        })
    },
    watch: {
        $route: {
            handler() {
                this.keyWord = this.$route.query.keyWord;
                this.schoolList = [];
                this.totalData = 0;
                this.currentPage = 1;
                this.levelList = [];
                this.levelTotal = 0;
                this.searchSchoolStatus = '1';
                this.searchMajorStatus = '1';
                if(this.activeIndex == '0') {
                    this.getSchoolListHandler('1');
                } else if(this.activeIndex == '1') {
                    this.getSpecialListHandler('1');
                }
            },
            deep: true,
        },
    },
    created() {
        this.$store.commit('user/ADDCOUNT', 0);
        this.schoolList = [];
        this.keyWord = this.$route.query.keyWord;
        this.getSearchDicHandler();
        setTimeout(()=>{
            this.getSchoolListHandler('1');
        }, 200)
    },
    methods: {
        getSearchDicHandler() {
            try {
                getSearchDic().then(res => {
                    if (res.status != 200 || !res) {
                        return
                    }
                    res.data.edu_type.map( item => {
                        this.type_edu[item.dic_code] = item.dic_value
                    })
                }).catch(error => {
                    console.log(error);
                })
            } catch (error) { console.log(error) }
        },
        getSchoolListHandler(page) {
            let scl_name = this.keyWord;
            getSchoolList({scl_name,page}).then(res => {
                const data = res.data;
                this.totalData = data.count;
                // let schoolList = [];
                if(data.count == 0) {
                    this.searchSchoolStatus = '2';
                    return
                }
                this.searchSchoolStatus = '3';
                // data.data.forEach((item) => {
                //     let obj = {};
                //     let school_type = '';
                //     let school_nature = '';
                //     let school_nature_type = '';
                //     obj = item;
                //     if(item.scl_type == '5000') {
                //         school_type = '综合'
                //     } else  if(item.scl_type == '5001') {
                //         school_type = '理工'
                //     } else  if(item.scl_type == '5002') {
                //         school_type = '农林'
                //     } else  if(item.scl_type == '5003') {
                //         school_type = '医药'
                //     } else  if(item.scl_type == '5004') {
                //         school_type = '师范'
                //     } else  if(item.scl_type == '5005') {
                //         school_type = '语言'
                //     } else  if(item.scl_type == '5006') {
                //         school_type = '财经'
                //     } else  if(item.scl_type == '5007') {
                //         school_type = '政法'
                //     } else  if(item.scl_type == '5008') {
                //         school_type = '体育'
                //     } else  if(item.scl_type == '5009') {
                //         school_type = '艺术'
                //     } else  if(item.scl_type == '5010') {
                //         school_type = '民族'
                //     } else  if(item.scl_type == '5011') {
                //         school_type = '军事'
                //     } else {
                //         school_type = '其他'
                //     }
                //     if(item.scl_nature == '36000') {
                //         school_nature = '公办'
                //     }else if(item.scl_nature == '36001') {
                //         school_nature = '民办'
                //     }
                //     if(item.scl_nature_type == '6000') {
                //         school_nature_type = '普通本科'
                //     } else if(item.scl_nature_type == '6001') {
                //         school_nature_type = '普通专科'
                //     } else if(item.scl_nature_type == '6002') {
                //         school_nature_type = '中外合作办学'
                //     }
                //     obj.school_type = school_type;
                //     obj.school_nature = school_nature;
                //     obj.school_nature_type = school_nature_type;
                //     schoolList.push(obj);
                // })
                this.schoolList = data.data;
            })
        },
        getSpecialListHandler(page) {
            getSpecialList(this.keyWord, '', '', page).then( res=> {
                this.levelTotal = res.data.count;
                if(res.data.count == 0) {
                    this.searchMajorStatus = '2';
                    return
                }
                this.searchMajorStatus = '3';
                let data = res.data.data;
                let newData = [];
                data.map((item,index) => {
                    let indexData = newData.findIndex(function(item1){
                        return item.level2_name == item1.level2_name; 
                    })
                    if(indexData != -1) {
                        let obj = newData[indexData];
                        let indexData1 = obj.levelList.findIndex(function(item1){
                            return item.level3_name == item1.level3_name; 
                        })
                        if(indexData1 != -1) {
                            let obj1 = obj.levelList[indexData1];
                            let levelList1 = obj1.levelList1;
                            levelList1.push(item);
                            obj1.levelList1 = levelList1;
                            obj.levelList[indexData1] = obj1;
                            this.$set(newData,indexData,obj);
                        } else {
                            let obj1 = {};
                            let levelList1 = [];
                            obj1.level3_name = item.level3_name;
                            levelList1.push(item);
                            obj1.levelList1 = levelList1;
                            obj.levelList.push(obj1);
                            this.$set(newData,indexData,obj);
                        }
                    } else {
                        let obj = {};
                        let obj1 = {};
                        let levelList = [];
                        let levelList1 = [];
                        levelList1.push(item);
                        obj1.level3_name = item.level3_name;
                        obj1.levelList1 = levelList1;
                        obj.level2_name = item.level2_name;
                        levelList.push(obj1);
                        obj.levelList = levelList;
                        newData.push(obj);
                    }
                })
                this.levelList = newData;
            })
        },
        handleChangeCard(e) {
            let type = parseInt(e.index);
            this.activeIndex = type;
            this.schoolList = [];
            this.totalData = 0;
            this.currentPage = 1;
            this.levelList = [];
            this.levelTotal = 0;
            this.searchSchoolStatus = '1';
            this.searchMajorStatus = '1';
            if(type == '0') {
                this.getSchoolListHandler('1');
            } else if(type == '1') {
                this.getSpecialListHandler('1');
            }
        },
        schoolDetailHandler(scl_id) {
			this.$router.push({
				path:'schoolDetail',
                query: {
                    scl_id: scl_id
                }
			})
		},
        clickHandler(special_id) {
            if(!special_id) {
                this.$message({
                    message: '暂无相关专业信息',
                    type: 'warning'
                })
                return
            }
            this.$router.push({
                path: '/majorDetail',
                query: {
                special_id: special_id
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    .search-box {
        @include gwidth;
    }
    .rank-box {
        border: none;
        background: #f5f7fa;
        box-shadow: none!important;
        margin-top: 24px;
    }
    .collapse-box {
		width: 100%;
        min-height: 330px;
		font-size: 0;
		img, .el-image {
			width: 64px;
			height: 64px;
		}
		.el-col-3 {
			width: 7%;
		}
        .el-col-4 {
            float: right;
        }
        .zytb-school-name {
            font-size: 18px;
            font-weight: 600;
            color: #2c2e33;
            margin-bottom: 5px;
        }
        .zytb-school-tag span {
            display: inline-block;
            padding: 3px 8px;
            font-size: 12px;
            color: #909399;
            height: 22px;
            background: #f0f2f5;
            border-radius: 4px;
            line-height: 22px;
            margin-right: 4px;
        }
        .zytb-school-major {
            color: $common-color;
            font-size: 14px;
            margin-top: 20px;
            position: relative;
            right: -6px;
        }
        .zytb-school-name img {
            width: 16px;
            height: 16px;
            position: relative;
            top: 2px;
            left: 5px;
            margin-left: 5px;
        }
        .zytb-school-name span {
            color: #909399;
            font-size: 12px;
            font-weight: 400;
            position: relative;
            top: -2px;
            left: 5px;
        }
        .zytb-school-tag {
            margin-top: 10px;
        }
        button {
            width: 100px;
            height: 30px;
            border: 1px solid $common-color;
            border-radius: 5px;
            color: $common-color!important;
            font-size: 14px;
            text-align: center;
            line-height: 30px;
            padding: 0;
            margin-top: 15px;
			background-color: #fff;
        }
        .el-col-4 {
            text-align: right;
        }
        button:hover {
            background-color: #fff;
        }
        .con-line {
            width: calc(100% - 78px);
            height: 1px;
            background: #f0f2f5;
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }
    .collapse-list {
        padding: 20px 0;
        position: relative;
        box-sizing: border-box;
    }
    .no-data-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        img {
            width: 110px;
            height: 110px;
        }
        p {
            font-size: 16px;
            text-align: center;
            color: #abaeb3;
        }
    }
    .collapse-box1 {
        width: 100%;
        font-size: 0;
        h2 {
            font-size: 22px;
            font-weight: 600;
            color: $common-color;
            margin: 24px 0;
        }
        h4 {
            font-size: 18px;
            font-weight: 600;
            color: #2c2e33;
            padding-bottom: 30px;
            margin-bottom: 0;
            border-bottom: 1px solid #f0f2f5;
        }
        .major-infor {
            height: 100px;
            padding: 20px 0 30px 20px;
        }
        .collapse-list {
            padding: 0;
        }
        .con-line {
            width: calc(100% - 20px);
        }
    }
</style>